<template>
  <div>
    <section>
      <TippCard
        hintID="Stundenabrechnung_Validierung_V1"
        text="Validierungsregeln werden automatisch bei der Prüfung von Stundenmeldungen angewendet und können Fehler in der Stundenmeldung automatisch kennzeichnen und ggf. beheben."
      >
      </TippCard>
      <v-snackbar v-model="helpers.snackbar.model" timeout="5000"
        >{{ helpers.snackbar.text }}.</v-snackbar
      >
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <Subheader
                icon="mdi-list-status"
                title="Regeln"
                :actions="actions"
              ></Subheader>
              <div class="mt-7">
                <v-data-table
                  :headers="helpers.validationRules.tableHeaders"
                  :items="validationRules"
                  sort-by="sortKey"
                  :sort-desc="false"
                  class="elevation-2"
                  no-data-text="Keine Validierungsregeln vorhanden"
                  single-expand
                  show-expand
                  :expanded.sync="helpers.validationRules.expanded"
                >
                  <template v-slot:item.isActive="{ item }">
                    <v-simple-checkbox
                      v-model="item.isActive"
                      color="primary"
                      disabled
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <v-card-text>
                        {{ item }}
                        <!-- <v-row dense>
                          <v-col cols="12">
                            <v-card outlined>
                              <v-card-subtitle>Variablen</v-card-subtitle>
                              <div
                                v-for="variable in item.customVariables"
                                :key="variable.id"
                              >
                                <v-divider></v-divider>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <code
                                        v-text="variable.options.pseudoId"
                                        class="mr-2"
                                      ></code
                                      >{{ variable.options.label
                                      }}<span v-if="variable.options.isRequired"
                                        >*</span
                                      >
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{
                                      variable.options.hint
                                    }}</v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list-item>
                              </div>
                              <div v-if="!item.customVariables.length">
                                <v-divider></v-divider>
                                <v-card-text class="grey--text"
                                  >Keine Variablen vorhanden.</v-card-text
                                >
                              </div>
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <v-card outlined>
                              <v-card-subtitle>Formel</v-card-subtitle>
                              <v-divider></v-divider>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <code v-text="item.formula"></code>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-card outlined>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    getTimeRoundingTypeText(
                                      item.timeRoundingType
                                    )
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle
                                    >Zeit runden auf</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-card outlined>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    timestampConverter(
                                      item.validDuration.start.timestamp
                                    )
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle
                                    >Verwendung zulässig
                                    ab</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-card outlined>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    timestampConverter(
                                      item.validDuration.end.timestamp
                                    )
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle
                                    >Verwendung zulässig
                                    bis</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                          <v-col cols="12" sm="6" md="3">
                            <v-card outlined>
                              <v-list-item>
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    getPaymentOfWagesTypeText(
                                      item.paymentOfWagesType
                                    )
                                  }}</v-list-item-title>
                                  <v-list-item-subtitle
                                    >Auszahlungsfälligkeit</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                        </v-row> -->
                      </v-card-text>
                      <v-card-actions class="px-4 pt-0 mt-n2 mb-2"
                        ><v-btn text outlined class="mr-2" disabled
                          ><v-icon left small>mdi-pencil</v-icon
                          >Bearbeiten</v-btn
                        ><v-btn text outlined color="error" disabled
                          ><v-icon left small>mdi-trash-can</v-icon
                          >Löschen</v-btn
                        ></v-card-actions
                      >
                    </td>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import { ACCOUNTING } from "@/store/modules.js";
import { GET_VALIDATION_RULES } from "@/store/action-types.js";
import { MEMBER_MANAGEMENT_CONFIG_RANKS_create } from "@/data/permission-types.js";

export default {
  name: "member-management-config-ranks",
  components: {
    TippCard,
    Subheader,
  },
  data() {
    return {
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus",
          permission: `${MEMBER_MANAGEMENT_CONFIG_RANKS_create}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "accounting-config-tab-validation-validation-rules-new",
            });
          },
        },
      ],
      helpers: {
        validationRules: {
          tableHeaders: [
            {
              text: "Priorität",
              value: "priority",
              sortable: true,
            },
            { text: "Bezeichnung", value: "title", sortable: false },
            {
              text: "Aktiv",
              value: "isActive",
              sortable: true,
            },
            { text: "", value: "data-table-expand", width: "1%" },
          ],
        },
        snackbar: { model: false, text: "" },
      },
    };
  },
  computed: {
    validationRules() {
      return this.$store.state.accounting.validationRules;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${ACCOUNTING}${GET_VALIDATION_RULES}`, {
        organizationId: this.$route.params.organizationId,
      });
    },
  },
};
</script>
